module.exports = __webpack_public_path__ + "static/media/11.32a64d86.mp3";